import ApiService from './api.service';

export const ElementService = {
  query(kioskId, componentId, params) {
    return ApiService.query(`kiosks/${kioskId}/components/${componentId}/elements`, {
      params,
    });
  },
  get(kioskId, componentId, slug) {
    return ApiService.get(`kiosks/${kioskId}/components/${componentId}/elements`, slug);
  },
  create(kioskId, componentId, params, config) {
    return ApiService.post(`kiosks/${kioskId}/components/${componentId}/elements`, { element: params }, config);
  },
  update(kioskId, componentId, slug, params, config) {
    return ApiService.update(`kiosks/${kioskId}/components/${componentId}/elements`, slug, { element: params }, config);
  },
  destroy(kioskId, componentId, slug) {
    return ApiService.delete(`kiosks/${kioskId}/components/${componentId}/elements`, slug);
  },
  duplicate(kioskId, componentId, slug, params = {}) {
    return ApiService.post(`kiosks/${kioskId}/components/${componentId}/elements/${slug}/duplicate`, params);
  },
  multiPartCreate(kioskId, componentId, params, config) {
    return ApiService.post(`kiosks/${kioskId}/components/${componentId}/elements`, params, config);
  },
  multiPartUpdate(kioskId, componentId, slug, params, config) {
    return ApiService.update(`kiosks/${kioskId}/components/${componentId}/elements`, slug, params, config);
  },
  recursiveGet(kioskId, componentId, elementId) {
    // console.log('element recursiveGet', { kioskId, componentId, elementId });
    let element;
    return ElementService.get(kioskId, componentId, elementId)
      .then(({ data }) => {
        element = data;
        element.children = [];
        return ElementService.recursiveGetChildren(kioskId, componentId, element.id);
      })
      .then((children) => {
        element.children = children;
        return element;
      })
      .catch(err => console.error({
        err,
        kioskId,
        componentId,
        elementId,
      }));
  },
  recursiveGetChildren(kioskId, componentId, elementId) {
    // console.log('element recursiveGetChildren', { kioskId, componentId, elementId });
    return ElementService.getChildren(kioskId, componentId, elementId)
      .then(({ data }) => {
        // console.log('got the children', data);
        let children = [];
        children = data.map(child => ElementService.recursiveGet(kioskId, child.component_id, child.id));
        return Promise.all(children);
      })
      .catch(err => console.error({
        err,
        kioskId,
        componentId,
        elementId,
      }));
  },
  getChildren(kioskId, componentId, elementId) {
    return ApiService.get(`kiosks/${kioskId}/components/${componentId}/elements/${elementId}/children`);
  },
};

export default ElementService;
